import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

export interface DeleteReferencedDataModel {
	title: string;
	message: string;
	items: string[];
}

@Component({
	template: `
		<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
			<h1 mat-dialog-title cdkDragHandle>{{ data.title }}</h1>
		</div>

		<div mat-dialog-content>
			<h2>{{ data.message }}</h2>

			<div class="delete-references-display">
				<ul>
					@for (ref of data.items; track ref) {
						<li>{{ ref }}</li>
					}
				</ul>
			</div>
		</div>

		<div mat-dialog-actions align="end">
			<button (click)="onClose()" mat-stroked-button color="primary">Close</button>
		</div>
	`,
	styles: [
		`
			@import 'theme-variables';

			:host {
				h2 {
					margin: 0;
					font-size: 1rem;
				}

				.delete-references-display {
					max-height: 30vh;
					overflow-y: auto;

					border: $light-line-border;
					border-radius: 0.25rem;

					ul {
						margin: 0.25rem 0;
						padding-left: 1.5rem;
					}
				}
			}
		`,
	],
	imports: [CommonModule, MatButtonModule, DragDropModule, MatDialogModule, MatProgressSpinnerModule],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteReferencedDataDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<DeleteReferencedDataDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DeleteReferencedDataModel,
	) {}

	onClose(): void {
		this.dialogRef.close();
	}
}
